const cfEditCategories = (() => {
    let categoryPageData;
    let filterValues;
    let newFilterValues;
    let addCateg;
    let backBtn;
    // DOM
    let pageWrap;
    let overviewTable;
    //--
    let filterPopup;
    let categoryDropdown;
    let categoryCodeDropdown;
    let categoryTypeDropdown;
    let categoryRapDropdown;
    let subCategoryDropdown;
    let subCategoryCodeDropdown;
    let applyFilterBtn;
    let btnWrap;
    let categoryBtnWrap;
    let categoryCodeBtnWrap;
    let categoryTypeBtnWrap;
    let categoryRapBtnWrap;
    let subCategoryBtnWrap;
    let subCategoryCodeBtnWrap;
    let accountname, registerID, pageName;


    async function init(accountName, registerId, page) {
        setActiveModuleAttribute('CFEditCategories');
        DOM.clearActionCenter();
        DOM.scrollToTopOfPage();
        initFilterValues();
        accountname = accountName;
        registerID = registerId;
        pageName = page;

        pageWrap = document.createElement('div');
        const backbtnWrap = document.createElement('div');
        backbtnWrap.classList.add('addOutcomeBtnWrap');
        const addInsertCategoryBtnWrap = document.createElement('div');
        addInsertCategoryBtnWrap.classList.add('addInsertServicesBtnWrap');
        backbtnWrap.appendChild(addInsertCategoryBtnWrap);

        filteredByData = buildFilteredByData();
        addCateg = addCategoryButton();

        backBtn = backButton(accountName, registerId, page);
        if ($.session.CFInsertCategory)
            addInsertCategoryBtnWrap.appendChild(addCateg);

        if (page == 'ConsumerFinance') {
            document.getElementById('mini_roster').style.display = 'none';
            backbtnWrap.appendChild(backBtn);
        }

        pageWrap.appendChild(backbtnWrap);
        pageWrap.appendChild(filteredByData);
        DOM.ACTIONCENTER.appendChild(pageWrap);

        const spinner = PROGRESS.SPINNER.get('Gathering Data...');
        pageWrap.appendChild(spinner);

        categoryPageData = await ConsumerFinancesAjax.getCategoryPageData({
            token: $.session.Token,
            category: filterValues.category,
            categoryCode: filterValues.categoryCode,
            categoryType: filterValues.categoryType,
            categoryRap: filterValues.categoryRap,
            subCategory: filterValues.subCategory,
            subCategoryCode: filterValues.subCategoryCode,
        });

        pageWrap.removeChild(spinner);
        buildOverviewTable();
    }


    function addCategoryButton() {
        return button.build({
            text: 'ADD NEW CATEGORY',
            style: 'secondary',
            type: 'contained',
            classNames: 'reportBtn',
            callback: async () => {
                if (!addCateg.classList.contains('disabled')) {
                    addCategory.init('0', '', '', '', '', accountname, registerID, pageName);
                }
            },
        });
    }

    function backButton(accountName, registerId) {
        return button.build({
            text: 'BACK',
            style: 'secondary',
            type: 'outlined',
            callback: async () => {
                setActiveModuleAttribute('ConsumerFinances');
                document.getElementById('mini_roster').style.display = 'block';
                if (registerId)
                    NewEntryCF.buildNewEntryForm(registerId);
                else {
                    NewEntryCF.init(accountName);
                }
            },
        });
    }

    function initFilterValues() {
        filterValues = {
            category: '%',
            categoryName: '%',
            categoryCode: '%',
            categoryCodeName: '%',
            categoryType: '%',
            categoryTypeName: '%',
            categoryRap: '%',
            categoryRapName: '%',
            subCategory: '%',
            subCategoryName: '%',
            subCategoryCode: '%',
            subCategoryCodeName: '%',
        };
    }

    function buildFilteredByData() {
        var currentFilterDisplay = document.querySelector('.filteredByData');

        if (!currentFilterDisplay) {
            currentFilterDisplay = document.createElement('div');
            currentFilterDisplay.classList.add('filteredByData');
            filterButtonSet();
            currentFilterDisplay.appendChild(btnWrap);
        }

        if (filterValues.category === '%') {
            btnWrap.appendChild(categoryBtnWrap);
            btnWrap.removeChild(categoryBtnWrap);
        } else {
            btnWrap.appendChild(categoryBtnWrap);
            if (document.getElementById('categoryBtn') != null)
                document.getElementById('categoryBtn').innerHTML = 'Category: ' + filterValues.categoryName;
        }

        if (filterValues.categoryCode == '%') {
            btnWrap.appendChild(categoryCodeBtnWrap);
            btnWrap.removeChild(categoryCodeBtnWrap);
        } else {
            btnWrap.appendChild(categoryCodeBtnWrap);
            if (document.getElementById('categoryCodeBtn') != null)
                document.getElementById('categoryCodeBtn').innerHTML = 'Category Code: ' + filterValues.categoryCodeName;
        }

        if (filterValues.categoryType == '%') {
            btnWrap.appendChild(categoryTypeBtnWrap);
            btnWrap.removeChild(categoryTypeBtnWrap);
        } else {
            btnWrap.appendChild(categoryTypeBtnWrap);
            if (document.getElementById('categoryTypeBtn') != null)
                document.getElementById('categoryTypeBtn').innerHTML = 'Category Type: ' + filterValues.categoryTypeName;
        }

        if (filterValues.categoryRap == '%') {
            btnWrap.appendChild(categoryRapBtnWrap);
            btnWrap.removeChild(categoryRapBtnWrap);
        } else {
            btnWrap.appendChild(categoryRapBtnWrap);
            if (document.getElementById('categoryRapBtn') != null)
                document.getElementById('categoryRapBtn').innerHTML = 'Category Rep Payee: ' + filterValues.categoryRapName;
        }

        if (filterValues.subCategory == '%') {
            btnWrap.appendChild(subCategoryBtnWrap);
            btnWrap.removeChild(subCategoryBtnWrap);
        } else {
            btnWrap.appendChild(subCategoryBtnWrap);
            if (document.getElementById('subCategoryBtn') != null)
                document.getElementById('subCategoryBtn').innerHTML = 'Subcategory: ' + filterValues.subCategoryName;
        }

        if (filterValues.subCategoryCode == '%') {
            btnWrap.appendChild(subCategoryCodeBtnWrap);
            btnWrap.removeChild(subCategoryCodeBtnWrap);
        } else {
            btnWrap.appendChild(subCategoryCodeBtnWrap);
            if (document.getElementById('subCategoryCodeBtn') != null)
                document.getElementById('subCategoryCodeBtn').innerHTML = 'Subcategory Code: ' + filterValues.subCategoryCodeName;
        }

        return currentFilterDisplay;
    }

    function filterButtonSet() {
        filterBtn = button.build({
            text: 'Filter',
            icon: 'filter',
            style: 'secondary',
            type: 'contained',
            classNames: 'filterBtnNew',
            callback: () => {
                showFilterPopup('ALL');
            },
        });

        categoryBtn = button.build({
            id: 'categoryBtn',
            text: 'Category: ' + filterValues.categoryName,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                showFilterPopup('categoryBtn');
            },
        });
        categoryCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('categoryBtn');
            },
        });

        categoryCodeBtn = button.build({
            id: 'categoryCodeBtn',
            text: 'Category Code: ' + filterValues.categoryCodeName,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                showFilterPopup('categoryCodeBtn');
            },
        });
        categoryCodeCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('categoryCodeBtn');
            },
        });

        categoryTypeBtn = button.build({
            id: 'categoryTypeBtn',
            text: 'Category Type: ' + filterValues.categoryTypeName,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                showFilterPopup('categoryTypeBtn');
            },
        });
        categoryTypeCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('categoryTypeBtn');
            },
        });

        categoryRapBtn = button.build({
            id: 'categoryRapBtn',
            text: 'Category Rep Payee: ' + filterValues.categoryRapName,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                showFilterPopup('categoryRapBtn');
            },
        });
        categoryRapCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('categoryRapBtn');
            },
        });

        subCategoryBtn = button.build({
            id: 'subCategoryBtn',
            text: 'Subcategory: ' + filterValues.subCategoryName,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                showFilterPopup('subCategoryBtn');
            },
        });
        subCategoryCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('subCategoryBtn');
            },
        });

        subCategoryCodeBtn = button.build({
            id: 'subCategoryCodeBtn',
            text: 'Subcategory Code: ' + filterValues.subCategoryCodeName,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                showFilterPopup('subCategoryCodeBtn');
            },
        });
        subCategoryCodeCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('subCategoryCodeBtn');
            },
        });



        btnWrap = document.createElement('div');
        btnWrap.classList.add('filterBtnWrap');
        btnWrap.appendChild(filterBtn);

        categoryBtnWrap = document.createElement('div');
        categoryBtnWrap.classList.add('filterSelectionBtnWrap');
        categoryBtnWrap.appendChild(categoryBtn);
        categoryBtnWrap.appendChild(categoryCloseBtn);
        btnWrap.appendChild(categoryBtnWrap);

        categoryCodeBtnWrap = document.createElement('div');
        categoryCodeBtnWrap.classList.add('filterSelectionBtnWrap');
        categoryCodeBtnWrap.appendChild(categoryCodeBtn);
        categoryCodeBtnWrap.appendChild(categoryCodeCloseBtn);
        btnWrap.appendChild(categoryCodeBtnWrap);

        categoryTypeBtnWrap = document.createElement('div');
        categoryTypeBtnWrap.classList.add('filterSelectionBtnWrap');
        categoryTypeBtnWrap.appendChild(categoryTypeBtn);
        categoryTypeBtnWrap.appendChild(categoryTypeCloseBtn);
        btnWrap.appendChild(categoryTypeBtnWrap);

        categoryRapBtnWrap = document.createElement('div');
        categoryRapBtnWrap.classList.add('filterSelectionBtnWrap');
        categoryRapBtnWrap.appendChild(categoryRapBtn);
        categoryRapBtnWrap.appendChild(categoryRapCloseBtn);
        btnWrap.appendChild(categoryRapBtnWrap);

        subCategoryBtnWrap = document.createElement('div');
        subCategoryBtnWrap.classList.add('filterSelectionBtnWrap');
        subCategoryBtnWrap.appendChild(subCategoryBtn);
        subCategoryBtnWrap.appendChild(subCategoryCloseBtn);
        btnWrap.appendChild(subCategoryBtnWrap);

        subCategoryCodeBtnWrap = document.createElement('div');
        subCategoryCodeBtnWrap.classList.add('filterSelectionBtnWrap');
        subCategoryCodeBtnWrap.appendChild(subCategoryCodeBtn);
        subCategoryCodeBtnWrap.appendChild(subCategoryCodeCloseBtn);
        btnWrap.appendChild(subCategoryCodeBtnWrap);
    }

    function closeFilter(closeFilter) {
        if (closeFilter == 'categoryBtn') {
            filterValues.category = '%';
            filterValues.categoryName = '%';
            newFilterValues.category = '%';
            newFilterValues.categoryName = '%';
        }
        if (closeFilter == 'categoryCodeBtn') {
            filterValues.categoryCode = '%';
            filterValues.categoryCodeName = '%';
            newFilterValues.categoryCode = '%';
            newFilterValues.categoryCodeName = '%';
        }
        if (closeFilter == 'categoryTypeBtn') {
            filterValues.categoryType = '%';
            filterValues.categoryTypeName = '%';
            newFilterValues.categoryType = '%';
            newFilterValues.categoryTypeName = '%';
        }
        if (closeFilter == 'categoryRapBtn') {
            filterValues.categoryRap = '%';
            filterValues.categoryRapName = '%';
            newFilterValues.categoryRap = '%';
            newFilterValues.categoryRapName = '%';
        }
        if (closeFilter == 'subCategoryBtn') {
            filterValues.subCategory = '%';
            filterValues.subCategoryName = '%';
            newFilterValues.subCategory = '%';
            newFilterValues.subCategoryName = '%';
        }
        if (closeFilter == 'subCategoryCodeBtn') {
            filterValues.subCategoryCode = '%';
            filterValues.subCategoryCodeName = '%';
            newFilterValues.subCategoryCode = '%';
            newFilterValues.subCategoryCodeName = '%';
        }
        applyFilter();
    }

    function showFilterPopup(IsShow) {
        filterPopup = POPUP.build({});

        // Dropdowns
        categoryDropdown = dropdown.build({
            dropdownId: 'categoryDropdown',
            label: 'Category',
            style: 'secondary',
            value: filterValues.category,
        });

        categoryCodeDropdown = dropdown.build({
            dropdownId: 'categoryCodeDropdown',
            label: 'Category Code',
            style: 'secondary',
            value: filterValues.categoryCode,
        });

        categoryTypeDropdown = dropdown.build({
            dropdownId: 'categoryTypeDropdown',
            label: 'Category Type',
            style: 'secondary',
            value: filterValues.categoryType,
        });

        categoryRapDropdown = dropdown.build({
            dropdownId: 'categoryRapDropdown',
            label: 'Category Rep Payee',
            style: 'secondary',
            value: filterValues.categoryRap,
        });

        subCategoryDropdown = dropdown.build({
            dropdownId: 'subCategoryDropdown',
            label: 'Subcategory',
            style: 'secondary',
            value: filterValues.subCategory,
        });

        subCategoryCodeDropdown = dropdown.build({
            dropdownId: 'subCategoryCodeDropdown',
            label: 'Subcategory Code',
            style: 'secondary',
            value: filterValues.subCategoryCode,
        });


        const btnFilterWrap = document.createElement('div');
        btnFilterWrap.classList.add('btnWrap');
        applyFilterBtn = button.build({
            text: 'Apply',
            style: 'secondary',
            type: 'contained',
        });
        const cancelFilterBtn = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: function () {
                POPUP.hide(filterPopup);
            },
        });
        btnFilterWrap.appendChild(applyFilterBtn);
        btnFilterWrap.appendChild(cancelFilterBtn);

        if (IsShow == 'ALL' || IsShow == 'categoryBtn') {
            filterPopup.appendChild(categoryDropdown);
        }
        if (IsShow == 'ALL' || IsShow == 'categoryCodeBtn') {
            filterPopup.appendChild(categoryCodeDropdown);
        }
        if (IsShow == 'ALL' || IsShow == 'categoryTypeBtn') {
            filterPopup.appendChild(categoryTypeDropdown);
        }
        if (IsShow == 'ALL' || IsShow == 'categoryRapBtn') {
            filterPopup.appendChild(categoryRapDropdown);
        }
        if (IsShow == 'ALL' || IsShow == 'subCategoryBtn') {
            filterPopup.appendChild(subCategoryDropdown);
        }
        if (IsShow == 'ALL' || IsShow == 'subCategoryCodeBtn') {
            filterPopup.appendChild(subCategoryCodeDropdown);
        }

        filterPopup.appendChild(btnFilterWrap);

        POPUP.show(filterPopup);
        populatecategoriesDropdown();
        setupFilterEvents();
    }
    function setupFilterEvents() {
        newFilterValues = {};

        categoryDropdown.addEventListener('change', e => {
            var selectedOption = e.target.options[e.target.selectedIndex];
            newFilterValues.category = selectedOption.value;
            newFilterValues.categoryName = selectedOption.text;
        });

        categoryCodeDropdown.addEventListener('change', e => {
            var selectedOption = e.target.options[e.target.selectedIndex];
            newFilterValues.categoryCode = selectedOption.value;
            newFilterValues.categoryCodeName = selectedOption.text;
        });

        categoryTypeDropdown.addEventListener('change', e => {
            var selectedOption = e.target.options[e.target.selectedIndex];
            newFilterValues.categoryType = selectedOption.value;
            newFilterValues.categoryTypeName = selectedOption.text;
        });

        categoryRapDropdown.addEventListener('change', e => {
            var selectedOption = e.target.options[e.target.selectedIndex];
            newFilterValues.categoryRap = selectedOption.value;
            newFilterValues.categoryRapName = selectedOption.text;
        });

        subCategoryDropdown.addEventListener('change', e => {
            var selectedOption = e.target.options[e.target.selectedIndex];
            newFilterValues.subCategory = selectedOption.value;
            newFilterValues.subCategoryName = selectedOption.text;
        });

        subCategoryCodeDropdown.addEventListener('change', e => {
            var selectedOption = e.target.options[e.target.selectedIndex];
            newFilterValues.subCategoryCode = selectedOption.value;
            newFilterValues.subCategoryCodeName = selectedOption.text;
        });

        applyFilterBtn.addEventListener('click', async e => {
            POPUP.hide(filterPopup);
            if (!applyFilterBtn.classList.contains('disabled')) {
                applyFilter();
            }
        });
    }

    async function populatecategoriesDropdown() {

        const { getCategoryDropDownOfFilterResult: category } = await ConsumerFinancesAjax.getCategoryDropDownOfFilter();
        let categoryData = category.map(categorys => ({
            id: categorys.CategoryID,
            value: categorys.CategoryDescription,
            text: categorys.CategoryDescription,
        }));
        categoryData.unshift({ id: '%', value: '%', text: 'ALL' });
        dropdown.populate('categoryDropdown', categoryData, filterValues.category);

        const { getcategoryCodeDropDownOfFilterResult: categoryCode } = await ConsumerFinancesAjax.getcategoryCodeDropDownOfFilter();
        let categoryCodeData = categoryCode.map(categorycode => ({
            id: categorycode.CategoryID,
            value: categorycode.CategoryDescription,
            text: categorycode.CategoryDescription,
        }));
        categoryCodeData.unshift({ id: '%', value: '%', text: 'ALL' });
        dropdown.populate('categoryCodeDropdown', categoryCodeData, filterValues.categoryCode);

        const categoryTypeData = ([
            { id: 1, value: 'E', text: 'Expense' },
            { id: 2, value: 'I', text: 'Income' },
        ]);
        categoryTypeData.unshift({ id: '%', value: '%', text: 'ALL' });
        dropdown.populate('categoryTypeDropdown', categoryTypeData, filterValues.categoryType);

        const { getcategoryRapDropDownOfFilterResult: categoryRap } = await ConsumerFinancesAjax.getcategoryRapDropDownOfFilter();
        let categoryRapData = categoryRap.map(categoryrep => ({
            id: categoryrep.CategoryID,
            value: categoryrep.CategoryID,
            text: categoryrep.CategoryDescription,
        }));
        categoryRapData.unshift({ id: '%', value: '%', text: 'ALL' });
        dropdown.populate('categoryRapDropdown', categoryRapData, filterValues.categoryRap);


        const { getsubCategoryDropDownOfFilterResult: subCategory } = await ConsumerFinancesAjax.getsubCategoryDropDownOfFilter();
        let subCategoryData = subCategory.map(subcategory => ({
            id: subcategory.CategoryID,
            value: subcategory.SubCategoryDescription,
            text: subcategory.SubCategoryDescription,
        }));
        subCategoryData.unshift({ id: '%', value: '%', text: 'ALL' });
        dropdown.populate('subCategoryDropdown', subCategoryData, filterValues.subCategory);

        const { getsubCategoryCodeDropDownOfFilterResult: subCategoryCode } = await ConsumerFinancesAjax.getsubCategoryCodeDropDownOfFilter();
        let subCategoryCodeData = subCategoryCode.map(subcategorycode => ({
            id: subcategorycode.CategoryID,
            value: subcategorycode.SubCategoryDescription,
            text: subcategorycode.SubCategoryDescription,
        }));
        subCategoryCodeData.unshift({ id: '%', value: '%', text: 'ALL' });
        dropdown.populate('subCategoryCodeDropdown', subCategoryCodeData, filterValues.subCategoryCode);
    }


    async function applyFilter() {
        filterValues = { ...filterValues, ...newFilterValues };

        const spinner = PROGRESS.SPINNER.get('Gathering Data...');
        pageWrap.removeChild(overviewTable);
        pageWrap.appendChild(spinner);

        categoryPageData = await ConsumerFinancesAjax.getCategoryPageData({
            token: $.session.Token,
            category: filterValues.category,
            categoryCode: filterValues.categoryCode,
            categoryType: filterValues.categoryType,
            categoryRap: filterValues.categoryRap,
            subCategory: filterValues.subCategory,
            subCategoryCode: filterValues.subCategoryCode,
        });

        pageWrap.removeChild(spinner);

        buildOverviewTable();
        const newfilteredByData = buildFilteredByData();
        pageWrap.replaceChild(newfilteredByData, filteredByData);
        filteredByData = newfilteredByData;
    }

    function buildOverviewTable() {
        groupChildData();

        overviewTable = document.createElement('div');
        overviewTable.classList.add('outcomeTable');

        const mainHeading = document.createElement('div');
        mainHeading.classList.add('outcomeTable__header');
        mainHeading.innerHTML = `
            <div></div>
            <div>Category</div>
            <div>Type</div>
            <div>Code</div>
            <div></div>
            <div></div>
            `;
        overviewTable.appendChild(mainHeading);
        if (categoryPageData.pageDataParent != null) {

            categoryPageData.pageDataParent.forEach(parent => {
                const category = parent.category;
                var eventName;
                var type = parent.type == 'I' ? 'Income' : parent.type == 'E' ? 'Expense' : '';
                var code = parent.code == null ? '' : parent.code;
                const rowWrap = document.createElement('div');
                rowWrap.classList.add('outcomeTable__subTableWrap');

                // TOP LEVEL ROW
                //---------------------------------
                const mainDataRow = document.createElement('div');
                mainDataRow.classList.add('outcomeTable__mainDataRow', 'outcomeTable__dataRow');
                mainDataRow.value = parent.categoryId;
                const endIcon = document.createElement('div');
                endIcon.classList.add('outcomeTable__endIcon');

                const toggleIcon = document.createElement('div');
                toggleIcon.id = 'authToggle';
                toggleIcon.classList.add('outcomeTable__endIcon');
                toggleIcon.innerHTML = icons['keyArrowRight'];
                mainDataRow.innerHTML = `       
                    <div>${parent.category}</div> 
                    <div>${type}</div>
                    <div>${code}</div>   
                    <div></div>
                    `;
                mainDataRow.prepend(toggleIcon);
                if ($.session.CFInsertCategory == true) {
                    endIcon.innerHTML = icons['add'];
                } else {
                    endIcon.innerHTML = `<div></div>`;
                }

                mainDataRow.appendChild(endIcon);
                rowWrap.appendChild(mainDataRow);

                // SUB ROWS
                //---------------------------------
                const subRowWrap = document.createElement('div');
                subRowWrap.classList.add('outcomeTable__subRowWrap');

                const subHeading = document.createElement('div');
                subHeading.classList.add('outcomeTable__subHeader');
                subHeading.innerHTML = `
                    <div></div>
                    <div>Subcategory</div> 
                    <div></div>
                    <div></div>
                    <div>Code</div>
                    <div></div>
                    `;
                subRowWrap.appendChild(subHeading);

                if (categoryPageData.pageDataChild != null && categoryPageData.pageDataChild[category]) {
                    categoryPageData.pageDataChild[category].sort((a, b) => {
                        return parseInt(a.itemnum) - parseInt(b.itemnum);
                    });

                    categoryPageData.pageDataChild[category].forEach(child => {
                        const subDataRow = document.createElement('div');
                        var code = child.code == null ? '' : child.code;
                        subDataRow.classList.add('outcomeTable__subDataRow', 'outcomeTable__dataRow');
                        subDataRow.innerHTML = `
                            <div></div>
                            <div>${child.serviceType}</div> 
                            <div></div>
                            <div></div>
                            <div>${code}</div> 
                            <div></div> 
                            `;
                        subRowWrap.appendChild(subDataRow);

                        subDataRow.addEventListener('click', e => {
                            if ($.session.CFUpdateCategory == true) {
                                addSubcategory.init(child.categoryId, child.category, child.serviceType, child.code, accountname, registerID, pageName);
                            }
                        });
                    });
                }

                // EVENT
                //---------------------------------
                mainDataRow.addEventListener('click', e => {
                    if (eventName != 'toggle' && eventName != 'add') {
                        if ($.session.CFUpdateCategory == true) {
                            addCategory.init(parent.categoryId, parent.category, parent.type, parent.repPayee, parent.code, accountname, registerID, pageName);
                        }
                    }
                    eventName = '';
                });

                toggleIcon.addEventListener('click', e => {
                    const toggle = document.querySelector('#authToggle');
                    eventName = 'toggle';
                    if (subRowWrap.classList.contains('active')) {
                        // close it
                        subRowWrap.classList.remove('active');
                        toggleIcon.innerHTML = icons.keyArrowRight;
                    } else {
                        // open it
                        subRowWrap.classList.add('active');
                        toggleIcon.innerHTML = icons.keyArrowDown;
                    }
                });

                endIcon.addEventListener('click', e => {
                    eventName = 'add';
                    addSubcategory.init('0', parent.category, '', '', accountname, registerID, pageName);  
                });

                // ASSEMBLY
                //---------------------------------
                rowWrap.appendChild(subRowWrap);
                overviewTable.appendChild(rowWrap);
            });
        }
        pageWrap.appendChild(overviewTable);
    }

    function groupChildData() {
        if (!categoryPageData.pageDataChild) {
            return;
        }

        const groupedChildren = categoryPageData.pageDataChild.reduce((obj, child) => {
            if (!obj[child.category]) {
                obj[child.category] = [];
                obj[child.category].push(child);
            } else {
                obj[child.category].push(child);
            }

            return obj;
        }, {});

        categoryPageData.pageDataChild = { ...groupedChildren };
    }

    return {
        init
    };
})();
